export const getLabelById = (id, labelDictionary) => {
  const entity = labelDictionary.find(item => item.id === id);
  return entity ? entity.label : null; // Devuelve el label si se encuentra, o null si no
};